<section>
	<h3 data-cy="validateDesignTitle" i18n="@@ValidateDesignTitle">Validate design</h3>
	<div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="0px" fxLayoutGap.gt-sm="70px">
		<div class="validate-design" fxFlex="auto" fxFlex.gt-sm="50%">
			<h4 i18n="@@ValidateDesignCheckDesignTitle"
				>1. Check that the product design looks visually correct</h4
			>
			@if (productImages.length > 0) {
				<g-product-media-viewer [items]="productImages" />
			}
			<p i18n="@@ValidateDesignCheckDesignDescription"
				>Note: Product design will not look exactly the same as the final print product.</p
			>
			@if (viewport.isMediumOrLarger$ | async) {
				<g-product-additional-info [product]="product" />
			} @else {
				<div class="upload-state-container">
					@if ((isUploadDone$ | async) !== true) {
						<div class="is-uploading">
							<g-icon [icon]="icons.faSpinner" pulse />
							<span i18n="@@UploadInProgress">File upload in progress...</span>
						</div>
					}
					@if (isUploadSuccessful$ | async) {
						<div class="is-upload-successful">
							<g-icon [icon]="icons.faCircleCheck" />
							<span i18n="@@UploadSuccess">Upload was successful</span>
						</div>
					}
					@if (isUploadFailure$ | async) {
						<div class="is-upload-failure">
							<g-icon [icon]="icons.faTriangleExclamation" />
							<span i18n="@@UploadFailed">Upload has failed!</span>
							<button
								type="button"
								(click)="retryUpload()"
								class="btn btn-secondary btn-small"
								i18n="@@UploadFailedTryAgain"
								>Try again</button
							>
						</div>
					}
				</div>
				<div
					class="checkbox-container"
					[ngClass]="{ 'is-disabled': (isUploadDone$ | async) !== true || (isUploadFailure$ | async) }"
				>
					<label for="validate-design-terms-accepted-1">
						<input
							type="checkbox"
							id="validate-design-terms-accepted-1"
							validationCheckBox
							[disabled]="(isUploadDone$ | async) !== true || (isUploadFailure$ | async)"
							[checked]="isValidated$ | async"
							(change)="isValidated$.next(!isValidated$.value)"
							data-cy="validationCheckBox"
						/>
						<span i18n="@@DesignApproved">I approve the product draft</span>
					</label>
				</div>
			}
		</div>
		<aside fxFlex="auto" fxFlex.gt-sm="50%" class="confirm-product-options">
			@if (viewport.isSmallOrExtraSmall$ | async) {
				<hr />
			}
			<h4 i18n="@@ValidateDesignConfirmOptions">2. Confirm product options</h4>
			@if (hasSelectableOptions) {
				<div class="product-options-container">
					<g-product-option-selector
						[product]="product"
						[initialOptions]="initialOptions"
						[setToBottom]="['quantity', 'order_quantity']"
						[isValidationStep]="true"
						(selectedOptionsChanged)="selectedOptionsChanged.emit($event)"
					/>
				</div>
			}
			@if (viewport.isMediumOrLarger$ | async) {
				<div class="upload-state-container">
					@if ((isUploadDone$ | async) !== true) {
						<div class="is-uploading">
							<g-icon [icon]="icons.faSpinner" pulse />
							<span i18n="@@UploadInProgress">File upload in progress...</span>
						</div>
					} @else if (isUploadSuccessful$ | async) {
						<div class="is-upload-successful">
							<g-icon [icon]="icons.faCircleCheck" />
							<span i18n="@@UploadSuccess">Upload was successful</span>
						</div>
					} @else if (isUploadFailure$ | async) {
						<div class="is-upload-failure">
							<g-icon [icon]="icons.faTriangleExclamation" />
							<span i18n="@@UploadFailed">Upload has failed!</span>
							<button
								type="button"
								(click)="retryUpload()"
								class="btn btn-secondary btn-small"
								i18n="@@TryAgainButton"
								>Try again</button
							>
						</div>
					}
				</div>
				<div
					class="checkbox-container"
					[ngClass]="{ 'is-disabled': (isUploadDone$ | async) !== true || (isUploadFailure$ | async) }"
				>
					<label for="validate-design-terms-accepted-2">
						<input
							type="checkbox"
							id="validate-design-terms-accepted-2"
							[disabled]="(isUploadDone$ | async) !== true || (isUploadFailure$ | async)"
							[checked]="isValidated$ | async"
							(change)="isValidated$.next(!isValidated$.value)"
							data-cy="validationCheckBox"
						/>
						<span i18n="@@DesignApproved">I approve the product draft</span>
					</label>
				</div>
			}
			@if (showPrices) {
				<g-product-price [price]="price$ | async" [isVariableProduct]="isVariableProduct" />
			}
			@if (viewport.isSmallOrExtraSmall$ | async) {
				<hr />
				<g-product-additional-info [product]="product" />
			}
		</aside>
	</div>
</section>
